<template>
    <painel-component :itens="itensOne">

        <row-component>
            <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                <label>Nome:</label>
                <input-component :type-input="'text'" v-model="formData.name"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12'">
                <label>Status:</label>
                <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-4'">
                <button-submit @submit="submit" :items="buttonSubmit" class="me-2"/>
                <button-route v-if="buttonCheck.create" :items="buttonRoute"/>
            </row-col-component>
        </row-component>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 35%">Nome</th>
                <th scope="col" style="width: 35%">Status</th>
                <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                    Ações
                </th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(group, index) in user_group.data" :key="index">
                <td data-label="Nome">{{ group.name }}</td>
                <td data-label="Status">{{ statusString(group.status) }}</td>
                <td data-label="Ações">
                    <button-edit v-if="buttonCheck.edit" :route="'user-group-edit'" :id-param="group.id"/>
                    <button-delete v-if="buttonCheck.delete" @delete="destroyGroupUser(group)"/>
                    <button-show v-if="buttonCheck.show" :route="'user-group-show'" :id-param="group.id"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="user_group" :offset="3" @paginate="loadGroups"/>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ButtonShow from '@/components/buttons/ButtonShow';
import {useToast} from "vue-toastification";
import swal from "sweetalert";
import ButtonPagination from "@/components/buttons/ButtonPagination.vue";

const toast = useToast()

export default {
    name: 'UserGroupSearch',

    created() {
        this.$store.dispatch('updateNamePage', 'Grupo de Usuário')
        this.checkACL()
        this.loadGroups(1)
    },

    components: {
        ButtonPagination,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        ButtonEdit,
        ButtonDelete,
        ButtonShow
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            buttonSubmit: {
                icon: 'ti-search',
            },

            buttonRoute: {
                icon: 'ti-plus',
                route: '/user-group/create'
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false,
                delete: false
            },

            formData: {
                name: '',
                status: ''
            },

            searchSubmit: false
        }
    },

    methods: {

        submit() {
            this.loadGroups(1)
            this.searchSubmit = true
        },

        statusString(value) {
            if (value === '1')
                return 'Ativo'
            return 'Inativo'
        },

        loadGroups(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadGroups', {...this.params, page})
                    .then((r) => {
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        destroyGroupUser(item) {
            if (item.id == this.me.id) {
                toast.info("Você não pode excluir o próprio grupo!", {timeout: 2000});
                return false
            }
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar ${item.name}, ${this.me.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,

                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    this.$store.dispatch('destroyGroupUser', item.id).then(() => {
                        this.loadGroups(1)
                        toast.success('Cadastro deletado com sucesso', {timeout: 2000});
                    })
                        .catch(() => {
                            toast.error(`Não foi possivel deletar  ${item.name} `, {timeout: 2000});
                        })
                }
            });
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 1)
                .then((r) => {
                    if (r.data.indexOf('group-user-search') !== -1) {

                        if (r.data.indexOf('group-user-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('group-user-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('group-user-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('group-user-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        user_group() {
            return this.$store.state.user_group.items
        },

        params() {
            return {
                page: this.user_group.current_page,
                name: this.formData.name,
                status: this.formData.status
            }
        },

        me() {
            return this.$store.state.auth.me
        },

    }

}
</script>

<style src="@/assets/style/table.css">

</style>